const headerDataEditor = [
    {
      prop: "id",
      label: "序号",
      columnwidth: 50,
    },
    {
      prop: "HPName", 
      label: "医院",
      columnwidth: 280,
      options: [
      ]
    },
    {
      prop: "Doctor",
      label: "术者",
      columnwidth: 190,
    },
    {
      prop: "TechnicalOffices",
      label: "科室",
      columnwidth: 200,
    },
    {
      prop: "SurgeryCountPerYear", 
      label: "手术量/年",
      columnwidth: 180,
    },
  ];
  export default headerDataEditor
  